import type { Product } from '../types/domain';
/** Convert an entered (unit,qty) into base units using the product's factor. */
export const toBaseQty = (
  product: Product,
  unitName: string,
  qty: number,
): number => {
  const u = product.units.find((x) => x.unit === unitName) ?? product.units[0];
  return qty * (u?.factor ?? 1);
};
